import {
  SET_TITLE, APP_SET_INSTALLED, APP_SET_ONLINE, APP_SET_OFFLINE,
} from '../actions/constants/app.constants';

const initialState = {
  title: 'Sin Titulo',
  installed: false,
  online: true,
};

export default function appReducer(state = initialState, { type, payload }) {
  switch (type) {
    case SET_TITLE: {
      return {
        ...state, title: payload,
      };
    }
    case APP_SET_ONLINE: {
      return {
        ...state, online: true,
      };
    }
    case APP_SET_OFFLINE: {
      return {
        ...state, online: false,
      };
    }
    case APP_SET_INSTALLED: {
      return {
        ...state, installed: true,
      };
    }
    default:
      return state;
  }
}
